import React from 'react';
import { useIntl } from 'react-intl';
export function HeaderComponent(props: { name: string }) {
  const intl = useIntl();
  return <span>{intl.formatMessage({ id: props.name })}</span>;
}
